/**
 * Loader — a espera do app. Fonte: handoff/dc/Loader.dc.html e
 * handoff/11-prompt-telas-entrada.md § 5.
 *
 * Um traço de 44 unidades correndo por um caminho de 1111 dentro de um anel
 * de 128×128: `worm` move o dashoffset de 10 a 1165 em 3s, e `bump` dá o
 * solavanco no container, em linear, no mesmo ciclo. As duas juntas é que
 * fazem a leitura de "algo vivo trabalhando" em vez de um spinner girando.
 *
 * O gradiente é vertical, de `hsl(193,90%,55%)` a `hsl(223,90%,55%)` — o
 * ciano→azul do lote das telas de entrada.
 *
 * O `id` do gradiente é ÚNICO POR INSTÂNCIA (lacuna 2): dois loaders na
 * mesma página com `id="g"` fixo colidem, e o segundo pinta com o gradiente
 * do primeiro — que pode até já ter sido desmontado, deixando o traço preto.
 *
 * `rotulo` só é usado na tela de verificação. Em todo o resto do app o
 * loader é só a animação, sem texto (§ 5 do prompt).
 */

import React, { useId } from 'react';
import cx from '../../cx';
import s from './Loader.module.scss';

/** O caminho do traço: é o desenho, não um valor a ajustar. */
const CAMINHO =
  'M92,15.492S78.194,4.967,66.743,16.887c-17.231,17.938-28.26,96.974-28.26,96.974L119.85,' +
  '59.892l-99-31.588,57.528,89.832L97.8,19.349,13.636,88.51l89.012,16.015S81.908,38.332,' +
  '66.1,22.337C50.114,6.156,36,15.492,36,15.492a56,56,0,1,0,56,0Z';

export default function Loader({ tamanho = 76, rotulo, className = '', ...rest }) {
  const id = `lv-worm-${useId().replace(/[:]/g, '')}`;
  const tamanhoDaFonte = Math.max(12, Math.round(tamanho / 5.4));

  return (
    <div
      className={cx(s.raiz, className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      {...rest}
    >
      <svg
        className={s.anel}
        viewBox="0 0 128 128"
        style={{ width: tamanho, height: tamanho }}
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="hsl(193,90%,55%)" />
            <stop offset="100%" stopColor="hsl(223,90%,55%)" />
          </linearGradient>
        </defs>

        <circle
          r="56"
          cx="64"
          cy="64"
          fill="none"
          stroke="rgba(242,244,248,.1)"
          strokeWidth="16"
          strokeLinecap="round"
        />

        <path
          className={s.traco}
          d={CAMINHO}
          fill="none"
          stroke={`url(#${id})`}
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="44 1111"
          strokeDashoffset="10"
        />
      </svg>

      {rotulo && (
        <span className={s.rotulo} style={{ fontSize: tamanhoDaFonte }}>
          {rotulo}
        </span>
      )}
    </div>
  );
}
